import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';

import { getToken, clearToken } from '@iso/lib/helpers/utility';
import actions from './actions';

const history = createBrowserHistory();

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function* ({ payload }) {
    const { token, userRole } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        userRole,
        profile: 'Profile',
      });
    }
    yield put({ type: actions.LOGIN_ERROR });
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem('id_token', payload.token);
    yield localStorage.setItem('userRole', payload.userRole);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    yield clearToken();
    history.push('/');
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const token = getToken().get('idToken');
    const userRole = localStorage.getItem('userRole');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        userRole,
        profile: 'Profile',
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(checkAuthorization), fork(loginRequest), fork(loginSuccess), fork(loginError), fork(logout)]);
}
